import { render } from "./askAQuestionMessageForm.vue?vue&type=template&id=367971ec&ts=true"
import script from "./askAQuestionMessageForm.vue?vue&type=script&lang=ts"
export * from "./askAQuestionMessageForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__